@if(content) {
<icms-outlet [components]="content.components" />
}
